module.exports = __webpack_public_path__ + "static/img/76.6e6e46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/76.png
// module id = astl
// module chunks = 1